import React, { useMemo } from "react";
import { Link } from "react-router-dom";

export default function ScreenRecordHelp({ lang, platform, isWebClient }) {

    const link = useMemo(() => {
        if (platform === 'android') {
            return `/retro/help/screen-recording/android?lang=${lang}`;
        };        
        if (platform === 'ios') {
            return `/retro/help/screen-recording/ios?lang=${lang}`;
        };
        return "";
    }, [platform, lang])

    const content = useMemo(() => {
        const phrases = {
            en: <p className="help-link">Not sure how to screen record? <Link to={link}>Click here</Link></p>,
            es: <p className="help-link">¿No estás seguro de cómo grabar la pantalla? <Link to={link}>Haga clic aquí</Link></p>,
            pt: <p className="help-link">Não sabe como rastrear o registro? <Link to={link}>Clique aqui</Link></p>,
            in: <p className="help-link">Tidak yakin bagaimana cara menyaring rekaman? <Link to={link}>Klik di sini</Link></p>,
            it: <p className="help-link">Non sai come registrare lo schermo? <Link to={link}>Fai clic qui</Link></p>,

        }
        return lang ? phrases[lang] : phrases.en
    }, [lang, link])


    if (platform === 'ios') {
        return (
            <> 
                {content}
            </>) 
    }
    if (platform === 'android' && isWebClient) {
        return (
            <>
                {content}
            </>
        ) 
        
    }
    return null

}